import React from 'react'
import { useNavigate } from 'react-router-dom'
import { openBooking } from '../../app/utils/links'
import "./Ourstory.css"
import livehood from "../../app/assets/images/icons/livehood.svg"
import youth from "../../app/assets/images/icons/youth-engement.svg"
import forest from "../../app/assets/images/icons/forest-conversation.svg"
import culture from "../../app/assets/images/icons/culture.svg"

function Ourstory() {
    const navigate = useNavigate();
    const supportData = [
        {
            id: 1,
            icon: <img loading="lazy" decoding="async" src={livehood} alt="Local Livelihoods" className="support-icon-img" />,
            title: "Local Livelihoods",
            description: "Ensuring 100% of our employment comes from the immediate community."
        },
        {
            id: 2,
            icon: <img loading="lazy" decoding="async" src={youth} alt="Youth Engagement" className="support-icon-img" />,
            title: "Youth Engagement",
            description: "Training programs for local youth in hospitality and wildlife guiding."
        },
        {
            id: 3,
            icon: <img loading="lazy" decoding="async" src={forest} alt="Forest Conservation" className="support-icon-img" />,
            title: "Forest Conservation",
            description: "Direct funding for reforestation and anti-poaching community patrols."
        },
        {
            id: 4,
            icon: <img loading="lazy" decoding="async" src={culture} alt="Cultural Preservation" className="support-icon-img" />,
            title: "Cultural Preservation",
            description: "Reviving Kumaoni traditions, from architecture to organic farming."
        }
    ];
    return (
        <>
            <section className="section-padding banner_sec ourstory-banner">
                <div className="container ">
                    <div className="banner-wraper">
                        <h1 className="banner-heading text-center">Our <span>Story</span></h1>
                        <p className="content text-white text-center">
                            Founded on the belief that travel should nourish both the visitor and the landscape,
                            Camp Hornbill is a testament to the power of community-led conservation in Kyari village.
                        </p>
                    </div>
                </div>
            </section>


            {/* Philosophy Section */}
            <section className="section-padding">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="heading">Our <span>Philosophy</span></h2>
                        <div className="diveder-bx"></div>
                    </div>
                    <div className="row align-items-stretch bg-color">
                        <div className="col-md-6">
                            <div className='about-bx'>
                                <div className="mb-5">
                                <h4 className="heading">Vision</h4>
                                <p className="content">To create a living forest space where tourism supports both nature and community.</p>
                            </div>
                            <div className="mb-5">
                                <h4 className="heading mb-3">Mission</h4>
                                <p className="content">To offer meaningful travel experiences that strengthen rural livelihoods and protect the forest ecosystem.</p>
                            </div>
                                <div>
                                    <p className="content">
                                        We believe that tourism can be a force for good - when it is rooted, respectful, and responsible.
                                    </p>
                                    <p><strong>That means:</strong></p>
                                    <ol class="list-group list-group-numbered border-0 custom-list">
                                        <li class="list-group-item">Keeping our footprint light</li>
                                        <li class="list-group-item">Preserving natural and cultural heritage</li>
                                        <li class="list-group-item">Creating meaningful exchanges between guests and hosts</li>
                                        <li class="list-group-item">Ensuring that growth benefits the community first</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-4 mt-md-0 g-0">
                            <div className="h-100">
                            <img loading="lazy" decoding="async"
                                src={require("../../app/assets/images/waste-management.webp")}
                                alt="Forest Path"
                                className="philosophy-img shadow"
                            />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Where It Began Section */}
            <section className="section-padding bg-color">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="image-wrapper">
                                <img loading="lazy" decoding="async" src={require("../../app/assets/images/where-it-began.webp")} alt="Kyari Village" className="img-fluid shadow" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <h2 className="heading mb-4">Where it <span>began.</span></h2>
                            <p className="content">
                                Camp Hornbill began in 2011 as a simple idea to create a form of travel that protects the forest while supporting the people who call it home.
                            </p>
                            <p className="content">
                                Set in Kyari village, on the edge of the Sitabani Conservation Reserve near Jim Corbett, the camp was built by local residents who had witnessed the impact of rapid, unchecked tourism in the region. Instead of becoming another resort, they chose a different path, one that was slower, more responsible, and deeply connected to the land.
                            </p>
                            <p className='content'>
                                What started with a few tents and a shared vision has grown into a community-run eco jungle lodge, where every aspect from construction to experiences, is shaped by local knowledge and participation.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* A Different Way to Travel Section */}
            <section className="section-padding">
                <div className="container">
                    <div className="row align-items-center flex-column-reverse flex-lg-row">
                        <div className="col-lg-6">
                            <h2 className="heading mb-4">A Different Way to <span>Travel</span></h2>
                            <p className="content mb-4">
                                At Camp Hornbill, travel is not about ticking off destinations.
 It is about immersing, observing, and belonging.
                            </p>
                            <p><strong>Guests are invited to:</strong></p>
                         <ol class="list-group list-group-numbered border-0 custom-list">
                                        <li class="list-group-item">Walk through forests guided by those who know them best</li>
                                        <li class="list-group-item">Share meals rooted in local traditions</li>
                                        <li class="list-group-item">Experience village life beyond the surface</li>
                                        <li class="list-group-item">Learn directly from nature and community</li>
                                    </ol>
                                    <p className='content'>
                                        This is not curated luxury - it is an authentic, lived experience.
                                    </p>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="image-wrapper">
                                <img loading="lazy" decoding="async" src={require("../../app/assets/images/way to-travel.webp")} alt="Our Community" className="img-fluid shadow" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Built by the Community Section */}
            <section className="section-padding">
                <div className="container">
                    <div className="row align-items-center flex-lg-row">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="image-wrapper">
                                <img loading="lazy" decoding="async" src={require("../../app/assets/images/community-build.webp")} alt="Our Community" className="img-fluid shadow" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <h2 className="heading mb-4">Built by the <span>Community</span></h2>
                            <p className="content mb-4">
                                Camp Hornbill is owned and operated by the people of Kyari.  Today, it supports local livelihoods across hospitality, guiding, farming, and conservation work.
                            </p>
                            <p className="content">
                                In 2022, this vision expanded with the formation of the <strong>Kumaon Maati Foundation</strong>, a community-led initiative focused on:
                            </p>
                            <ol class="list-group list-group-numbered border-0 custom-list">
                                        <li class="list-group-item">Environmental conservation</li>
                                        <li class="list-group-item">Youth engagement and skill-building</li>
                                        <li class="list-group-item">Cultural preservation</li>
                                        <li class="list-group-item">Sustainable rural development</li>
                                    </ol>
                                    <p className="content">
                                        Every stay contributes directly to this ecosystem.
                                    </p>
                        </div>
                        
                    </div>
                </div>
            </section>

            {/* Supports Section */}
            <section className="section-padding bg-color text-center">
                <div className="container">
                    <div className='heading-content-wraper'>
                        <h2 className="heading mb-2">What Your Stay <span>Supports</span></h2>
                        <div className="section-divider"></div>
                    </div>
                    <div className="row g-4 justify-content-center">
                        {supportData.map((item) => (
                            <div key={item.id} className="col-lg-3 col-md-6">
                                <div className="support-card">
                                    <div className="icon-container mb-4">
                                        {/* You can use SVGs or Icon Fonts here */}
                                        {item.icon}
                                    </div>
                                    <h4 className="sub-heading">{item.title}</h4>
                                    <p className="content text-start">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* Where We Are Today */}
            <section className="section-padding text-center">
                <div className="container">
                    <div className="heading-content-wraper">
                        <h2 className="heading mb-4">Where We Are <span>Today</span></h2>
                        <p className="content mb-5">
                            Today, Camp Hornbill stands as a beacon of hope. We have shown that when a
                            community takes ownership of its environment, the results are transformative.
                            We are more than a camp; we are a movement of people who believe in the wild.
                        </p>
                    </div>
                    <img loading="lazy" decoding="async" src={require("../../app/assets/images/where-we-are.webp")} alt="Nature Today" className="img-fluid rounded-5 shadow-lg w-100" style={{ maxHeight: '650px', objectFit: 'cover', maxWidth: "1150px", margin: "0px auto" }} />
                </div>
            </section>

            {/* Call to Action */}
            <section className="section-padding bg-color">
                <div className="container">
                    <h2 className="heading text-center mb-4">Experience the Story Yourself</h2>
                    <div className="d-flex justify-content-center gap-3">
                        <button className="primary_btn" onClick={openBooking}>Plan Your Stay</button>
                        <button className="outline_btn" onClick={() => navigate("/experience")}>Explore Experiences</button>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Ourstory